const UrlApi = {
  // baseUrl: "https://api-dev.safrati.ai/admin",
  // baseUrlImage: "https://api-dev.safrati.ai/admin",
  // baseUrlclient: "https://api-dev.safrati.ai/user",
  // baseUrlImageClient: "https://api-dev.safrati.ai/user",
  baseUrl: process.env.REACT_APP_BASEURL,
  baseUrlImage: process.env.REACT_APP_BASEURLIMAGE,
  baseUrlclient: process.env.REACT_APP_BASEURL_CLIENT,
  baseUrlImageClient: process.env.REACT_APP_BASEURLIMAGE,
  auth: {
    login: "auth/login",
    autologin: "auth/autologin",
    signup: "auth/signup",
    logout: "auth/logout",
    forgotPassword: "auth/forgot-password",
    resetPassword: "auth/reset-password",
  },
  admins: {
    get: "admins/get",
    add: "admins/add",
    edit: "admins/edit",
    delete: "admins/delete",
    getUserType: "admins/get_user_type",
    getUserPrivilegs: "admins/privileg",
    addUserPrivilegs: "admins/addprivileg",
    editUserPrivilegs: "admins/editprivileg",
    deleteprivileg: "admins/deleteprivileg",
    dashboard: "admins/getDash",
  },
  users: {
    get: "users/get",
    add: "users/add",
    edit: "users/edit",
    delete: "users/delete",
    get_countries: "users/get_countries",
  },
  admin_logs: {
    get: "admins/get",
    edit: "admins/edit"
  },
  settings: {
    get: "settings/get",
    edit: "settings/update",
    updateLogo: "settings/update-logo",
    updateImages: "settings/update-images",
  },
  reOrder: "re-order",
  copy: {
    create: "copy/create",
  },
  stats: {
    get: "home/stats",
    add: "home/add_stats",
    edit: "home/update_stats",
    delete: "home/delete_stats",
  },
  clients: {
    get: "clients/get",
    add: "clients/add",
    edit: "clients/edit",
    delete: "clients/delete",
    search: "clients/search",
  },
  services: {
    get: "services/get",
    add: "services/add",
    edit: "services/update",
    delete: "services/delete",
    dashboard: "services/getDash",
  },
  contact_us: {
    get: "contact_us/get",
    add: "contact_us/add",
    edit: "contact_us/update",
    delete: "contact_us/delete",
    dashboard: "contact_us/getDash",
  },
  quality: {
    get: "quality/get",
    add: "quality/add",
    edit: "quality/update",  // Note: Using 'update' to match your route
    delete: "quality/delete",
    dashboard: "quality/getDash",
  },
  our_team: {
    get: "our_team/get",
    add: "our_team/add",
    edit: "our_team/update",
    delete: "our_team/delete",
    dashboard: "our_team/getDash",
  },
  slideshow: {
    get: "slideshow/get",
    add: "slideshow/add",
    edit: "slideshow/update",
    delete: "slideshow/delete",
    dashboard: "slideshow/getDash",
  },
  companies: {
    get: "companies/get",
    add: "companies/add",
    edit: "companies/update",
    delete: "companies/delete",
  },
  projects: {
    get: "projects/get",
    add: "projects/add",
    edit: "projects/update",
    delete: "projects/delete",
    dashboard: "projects/getDash",
  },
  media: {
    get: "media/get",
    add: "media/add",
    edit: "media/edit",
    delete: "media/delete",
  },
  statistics: {
    get: "statistics/get",
    add: "statistics/add",
    edit: "statistics/update",
    delete: "statistics/delete",
    reorder: "statistics/reorder",
  },
  sponsors: {
    get: "sponsors/get",
    add: "sponsors/add",
    edit: "sponsors/update",
    delete: "sponsors/delete",
    reorder: "sponsors/reorder",
  },
  galleries: {
    get: "galleries/get",
    add: "galleries/add",
    edit: "galleries/update",
    delete: "galleries/delete",
    reorder: "galleries/reorder",
  },
  gallery_items: {
    get: "gallery_items/get",
    add: "gallery_items/add",
    addMultiple: "gallery_items/add-multiple",
    edit: "gallery_items/update",
    delete: "gallery_items/delete",
    reorder: "gallery_items/reorder",
  },
  executive_committee: {
    get: "executive_committee/get",
    add: "executive_committee/add",
    edit: "executive_committee/update",
    delete: "executive_committee/delete",
    reorder: "executive_committee/reorder",
  },
  general_commission: {
    get: "general_commission/get",
    add: "general_commission/add",
    edit: "general_commission/update",
    delete: "general_commission/delete",
    reorder: "general_commission/reorder",
  },
  contact_locations: {
    get: "contact_locations/get",
    add: "contact_locations/add",
    edit: "contact_locations/update",
    delete: "contact_locations/delete",
    setPrimary: "contact_locations/set-primary",
  },
  memorials: {
    get: "memorials/get",
    add: "memorials/add",
    edit: "memorials/update",
    delete: "memorials/delete",
    reorder: "memorials/reorder",
  },
  locate_us: {
    get: "locate_us/get",
    add: "locate_us/add",
    edit: "locate_us/update",
    delete: "locate_us/delete",
  },
  formations: {
    get: "formations/get",
    add: "formations/add",
    edit: "formations/update",
    delete: "formations/delete",
    reorder: "formations/reorder",
  },
  home_sections: {
    get: "home_sections/get",
    add: "home_sections/add",
    edit: "home_sections/update",
    delete: "home_sections/delete",
    reorder: "home_sections/reorder",
  },
  media_posts: {
    get: "media_posts/get",
    add: "media_posts/add",
    edit: "media_posts/update",
    delete: "media_posts/delete",
    updateStatus: "media_posts/update-status",
    toggleFeatured: "media_posts/toggle-featured",
  },
  sections: {
    get: "sections/get",
    add: "sections/add",
    edit: "sections/update",
    delete: "sections/delete",
    reorder: "sections/reorder",
  },
};

export default UrlApi;
